import React from 'react';

function PortfolioResults({ data }) {
  if (!data) return null;

  return (
    <div id="portfolio-results" className="portfolio-results">
      <h3 id="portfolio-results-heading">Optimization Results</h3>
      
      <div id="portfolio-results-grid" className="results-grid">
        <div id="result-card-weights" className="result-card">
          <h4 id="weights-card-heading">Portfolio Weights & Returns</h4>
          <div id="portfolio-weights-list" className="weights-list">
            {data.weights && Object.entries(data.weights)
              .filter(([, weight]) => weight > 0.001)
              .sort(([,a], [,b]) => b - a)
              .map(([stock, weight]) => {
                const stockInfo = data.stocks?.find(s => s.symbol === stock);
                const individualReturn = data.individual_returns?.[stock];
                return (
                  <div key={stock} id={`portfolio-weight-item-${stock}`} className="weight-item">
                    <div id={`portfolio-weight-item-${stock}-info`} className="stock-info">
                      <span className="stock-symbol">{stock}</span>
                      {stockInfo && (
                        <span className="stock-name">{stockInfo.name}</span>
                      )}
                    </div>
                    <div id={`portfolio-weight-item-${stock}-metrics`} className="stock-metrics">
                      <div id={`portfolio-weight-item-${stock}-weight-metric`} className="weight-metric">
                        <span className="metric-label">Weight:</span>
                        <span className="weight-value">{(weight * 100).toFixed(1)}%</span>
                      </div>
                      {individualReturn && (
                        <div id={`portfolio-weight-item-${stock}-return-metric`} className="return-metric">
                          <span className="metric-label">Expected Return:</span>
                          <span className="return-value">{(individualReturn * 100).toFixed(1)}%</span>
                        </div>
                      )}
                      {stockInfo && (
                        <div id={`portfolio-weight-item-${stock}-beta-metric`} className="beta-metric">
                          <span className="metric-label">Beta:</span>
                          <span className="beta-value">{stockInfo.beta}</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div id="result-card-metrics" className="result-card">
          <h4 id="metrics-card-heading">Portfolio Metrics</h4>
          <div id="portfolio-metrics-list" className="metrics-list">
            <div id="metric-item-expected-return" className="metric-item">
              <span className="metric-label">Expected Return:</span>
              <span className="metric-value">{(data.expected_return * 100).toFixed(2)}%</span>
            </div>
            <div id="metric-item-volatility" className="metric-item">
              <span className="metric-label">Volatility:</span>
              <span className="metric-value">{(data.volatility * 100).toFixed(2)}%</span>
            </div>
            <div id="metric-item-sharpe" className="metric-item">
              <span className="metric-label">Sharpe Ratio:</span>
              <span className="metric-value">{data.sharpe_ratio?.toFixed(3) || 'N/A'}</span>
            </div>
            <div id="metric-item-target-beta" className="metric-item">
              <span className="metric-label">Target Beta:</span>
              <span className="metric-value">{data.target_beta?.toFixed(3) || 'N/A'}</span>
            </div>
            {data.target_performance && (
              <div id="metric-item-target-performance" className="metric-item">
                <span className="metric-label">Target Performance:</span>
                <span className="metric-value">{(data.target_performance * 100).toFixed(2)}%</span>
              </div>
            )}
            {data.performance_criteria && (
              <div id="metric-item-performance-criteria" className="metric-item">
                <span className="metric-label">Performance Criteria:</span>
                <span className="metric-value">{data.performance_criteria}</span>
              </div>
            )}
            {data.performance_achievable !== undefined && (
              <div id="metric-item-performance-achievable" className="metric-item">
                <span className="metric-label">Performance Achievable:</span>
                <span className="metric-value" style={{ color: data.performance_achievable ? '#27ae60' : '#e74c3c' }}>
                  {data.performance_achievable ? 'Yes' : 'No'}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {data.message && (
        <div id="optimization-message" className={`optimization-message ${data.performance_achievable === false ? 'performance-warning' : ''}`}>
          <p id="optimization-message-text">{data.message}</p>
        </div>
      )}
    </div>
  );
}

export default PortfolioResults;
